<template>
  <div class="p-6 min-h-screen flex justify-center items-center" style="--tw-bg-opacity: 1;background-color: rgba(79, 181, 168, var(--tw-bg-opacity))">
    <div class="w-full max-w-md">
      <!--      <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />-->
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-12">
          <img :src="'logo.jpg'" style="display: block;margin:0 auto;" alt="Logo" />
          <div class="mx-auto mt-6 w-24 border-b-2" /><br />
          <p class="text-center font-bold text-2xl">Redefinir Senha</p>
          <flash-messages />
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Digite seu Email" type="email" autofocus autocapitalize="off" />
        </div>
        <div class="px-10 py-4 bg-gray-100 border-t border-gray-100 flex">
          <button type="button"><a href="/">Voltar</a></button>
          <loading-button :loading="form.processing" class="ml-auto btn-indigo" type="submit">Enviar link de redefinição de senha</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  metaInfo: { title: 'Login' },
  components: {
    LoadingButton,
    TextInput,
    FlashMessages,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: null,
      }),
    }
  },
  methods: {
    login() {
      this.form.post(this.route('forget.password.post'))
    },
  },
}
</script>
